/* tslint:disable */
/* eslint-disable */
/**
 * Business Portal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AccountPaginationResponseAllOfDataInnerAffiliationsInner
 */
export interface AccountPaginationResponseAllOfDataInnerAffiliationsInner {
    /**
     * 組織コード
     * @type {string}
     * @memberof AccountPaginationResponseAllOfDataInnerAffiliationsInner
     */
    organizationCode: string;
    /**
     * 会社コード
     * @type {string}
     * @memberof AccountPaginationResponseAllOfDataInnerAffiliationsInner
     */
    companyCode?: string;
    /**
     * 子会社ID
     * @type {string}
     * @memberof AccountPaginationResponseAllOfDataInnerAffiliationsInner
     */
    companyId?: string;
    /**
     * 営業所ID
     * @type {string}
     * @memberof AccountPaginationResponseAllOfDataInnerAffiliationsInner
     */
    salesOfficeId?: string;
    /**
     * アカウント連携種別 (0:アカウント登録 , 1:所属追加)
     * @type {number}
     * @memberof AccountPaginationResponseAllOfDataInnerAffiliationsInner
     */
    type: number;
}

/**
 * Check if a given object implements the AccountPaginationResponseAllOfDataInnerAffiliationsInner interface.
 */
export function instanceOfAccountPaginationResponseAllOfDataInnerAffiliationsInner(value: object): value is AccountPaginationResponseAllOfDataInnerAffiliationsInner {
    if (!('organizationCode' in value) || value['organizationCode'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function AccountPaginationResponseAllOfDataInnerAffiliationsInnerFromJSON(json: any): AccountPaginationResponseAllOfDataInnerAffiliationsInner {
    return AccountPaginationResponseAllOfDataInnerAffiliationsInnerFromJSONTyped(json, false);
}

export function AccountPaginationResponseAllOfDataInnerAffiliationsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccountPaginationResponseAllOfDataInnerAffiliationsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'organizationCode': json['organization_code'],
        'companyCode': json['company_code'] == null ? undefined : json['company_code'],
        'companyId': json['company_id'] == null ? undefined : json['company_id'],
        'salesOfficeId': json['sales_office_id'] == null ? undefined : json['sales_office_id'],
        'type': json['type'],
    };
}

export function AccountPaginationResponseAllOfDataInnerAffiliationsInnerToJSON(json: any): AccountPaginationResponseAllOfDataInnerAffiliationsInner {
    return AccountPaginationResponseAllOfDataInnerAffiliationsInnerToJSONTyped(json, false);
}

export function AccountPaginationResponseAllOfDataInnerAffiliationsInnerToJSONTyped(value?: AccountPaginationResponseAllOfDataInnerAffiliationsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'organization_code': value['organizationCode'],
        'company_code': value['companyCode'],
        'company_id': value['companyId'],
        'sales_office_id': value['salesOfficeId'],
        'type': value['type'],
    };
}

